export const getMonthsByLocale = (locale: string) =>
  Array(...Array(12)).map((_, i) => {
    const date = new Date();
    date.setDate(i);
    date.setMonth(i);
    return date.toLocaleString(locale, { month: 'short' });
  });

export const toISODateString = ({
  day,
  month,
  year,
}: {
  day: string;
  month: string;
  year: string;
}) => {
  const date = new Date(Date.UTC(Number(year), Number(month), Number(day)));

  return date.toISOString().split('T')[0];
};

export const normalizeDateString = (
  dateString: string | null | undefined,
): string => {
  if (!dateString || typeof dateString !== 'string') {
    return '';
  }

  const trimmed = dateString.trim();

  if (trimmed.includes('T') && trimmed.includes('Z')) {
    try {
      const date = new Date(trimmed);
      if (isNaN(date.getTime())) return '';

      const year = date.getUTCFullYear();
      const month = String(date.getUTCMonth() + 1).padStart(2, '0');
      const day = String(date.getUTCDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    } catch (error) {
      return '';
    }
  }

  if (/^\d{4}-\d{2}-\d{2}$/.test(trimmed)) {
    return trimmed;
  }

  return '';
};

export const parseDateString = (dateStr: string, months: string[]) => {
  if (!dateStr || typeof dateStr !== 'string') return null;

  let year: string, month: string, day: string;

  const isoMatch = dateStr.match(
    /^(\d{4})-(\d{2})-(\d{2})T\d{2}:\d{2}:\d{2}\.\d{3}Z$/,
  );
  if (isoMatch) {
    [, year, month, day] = isoMatch;
  } else {
    const simpleMatch = dateStr.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (!simpleMatch) return null;
    [, year, month, day] = simpleMatch;
  }

  const monthNum = parseInt(month);
  const dayNum = parseInt(day);

  if (isNaN(monthNum) || monthNum < 1 || monthNum > 12) return null;
  if (isNaN(dayNum) || dayNum < 1 || dayNum > 31) return null;

  return {
    year,
    month: monthNum - 1,
    monthLabel: months[monthNum - 1] || '',
    day,
  };
};

export const checkIfDateIsValid = (
  day: string,
  month: string,
  year: string,
) => {
  const d = new Date(+year, +month, +day);
  return +month == d.getMonth();
};
